export const cityProvinces = [
  { lat: -8.719266, lng: 115.16864, name: "Badung", provinces: "Bali" },
  { lat: -1.2654, lng: 116.8312, name: "Balikpapan", provinces: "Kalimantan Timur" },
  { lat: -5.42544, lng: 105.25803, name: "Bandar Lampung", provinces: "Lampung" },
  { lat: -6.914864, lng: 107.608242, name: "Bandung", provinces: "Jawa Barat" },
  { lat: -3.4906, lng: 114.833, name: "Banjarbaru", provinces: "Kalimantan Selatan" },
  { lat: -3.341636, lng: 114.628846, name: "Banjarmasin", provinces: "Kalimantan Selatan" },
  { lat: -7.88806, lng: 110.32889, name: "Bantul", provinces: "DI Yogyakarta" },
  { lat: 0.837843, lng: 103.772925, name: "Batam", provinces: "Kepulauan Riau" },
  { lat: -7.871153, lng: 112.526925, name: "Batu", provinces: "Jawa Timur" },
  { lat: -5.044689, lng: 103.808703, name: "Baturaja", provinces: "Lampung" },
  { lat: -6.26541, lng: 106.97199, name: "Bekasi", provinces: "Jawa Barat" },
  { lat: -3.7928, lng: 102.2606, name: "Bengkulu", provinces: "Bengkulu" },
  { lat: 1.4668, lng: 125.110605, name: "Bitung", provinces: "Sulawesi Utara" },
  { lat: -6.6, lng: 106.8, name: "Bogor", provinces: "Jawa Barat" },
  { lat: -4.678436, lng: 119.528498, name: "Bone", provinces: "Sulawesi Selatan" },
  { lat: -6.30063, lng: 106.652087, name: "Bumi Serpong Damai", provinces: "Banten" },
  { lat: -6.4901, lng: 106.8307, name: "Cibinong", provinces: "Jawa Barat" },
  { lat: -6.403382, lng: 107.419333, name: "Cikampek", provinces: "Jawa Barat" },
  { lat: -6.0026, lng: 106.011, name: "Cilegon - Serang", provinces: "Banten" },
  { lat: -6.8841, lng: 107.5413, name: "Cimahi", provinces: "Jawa Barat" },
  { lat: -6.3077, lng: 106.7176, name: "Ciputat", provinces: "Banten" },
  { lat: -6.742776, lng: 108.519019, name: "Cirebon", provinces: "Jawa Barat" },
  { lat: 3.4581, lng: 98.9245, name: "Deli Serdang", provinces: "Sumatera Utara" },
  { lat: -8.65, lng: 115.216667, name: "Denpasar", provinces: "Bali" },
  { lat: -6.39, lng: 106.83, name: "Depok", provinces: "Jawa Barat" },
  { lat: -7.227906, lng: 107.908699, name: "Garut", provinces: "Jawa Barat" },
  { lat: -8.519268, lng: 115.263298, name: "Gianyar", provinces: "Bali" },
  { lat: 0.676363, lng: 121.235245, name: "Gorontalo", provinces: "Gorontalo" },
  { lat: -5.3103, lng: 119.7426, name: "Gowa", provinces: "Sulawesi Selatan" },
  { lat: -7.156576, lng: 112.65611, name: "Gresik", provinces: "Jawa Timur" },
  { lat: -6.1745, lng: 106.8227, name: "Jakarta", provinces: "DKI Jakarta" },
  { lat: -1.610263, lng: 103.539487, name: "Jambi", provinces: "Jambi" },
  { lat: -7.560709, lng: 111.979027, name: "Jombang", provinces: "Jawa Timur" },
  { lat: -6.3054, lng: 107.320233, name: "Karawang", provinces: "Jawa Barat" },
  { lat: -7.842246, lng: 111.946146, name: "Kediri", provinces: "Jawa Timur" },
  { lat: -3.984876, lng: 122.467004, name: "Kendari", provinces: "Sulawesi Tenggara" },
  { lat: -10.1749436, lng: 123.5446778, name: "Kupang", provinces: "Nusa Tenggara Timur" },
  { lat: -7.122271, lng: 112.03227, name: "Lamongan", provinces: "Jawa Timur" },
  { lat: -7.631059, lng: 111.530016, name: "Madiun", provinces: "Jawa Timur" },
  { lat: -5.1477, lng: 119.4327, name: "Makassar", provinces: "Sulawesi Selatan" },
  { lat: -7.983908, lng: 112.621391, name: "Malang", provinces: "Jawa Timur" },
  { lat: 1.48218, lng: 124.84892, name: "Manado", provinces: "Sulawesi Utara" },
  { lat: -4.964402, lng: 119.439431, name: "Maros", provinces: "Sulawesi Selatan" },
  { lat: -8.58333, lng: 116.11667, name: "Mataram", provinces: "Nusa Tenggara Barat" },
  { lat: 3.595196, lng: 98.672223, name: "Medan", provinces: "Sumatera Utara" },
  { lat: -7.471446, lng: 112.421721, name: "Mojokerto", provinces: "Jawa Timur" },
  { lat: -0.94924, lng: 100.35427, name: "Padang", provinces: "Sumatera Barat" },
  { lat: -2.976074, lng: 104.775431, name: "Palembang", provinces: "Sumatera Selatan" },
  { lat: -2.115909, lng: 106.085507, name: "Pangkal Pinang", provinces: "Kepulauan Bangka Belitung" },
  { lat: 0.382144, lng: 101.697364, name: "Pangkalan Kerinci", provinces: "Riau" },
  { lat: -4.012708, lng: 119.603128, name: "Pare Pare", provinces: "Sulawesi Selatan" },
  { lat: -6.895856, lng: 109.639484, name: "Pekalongan", provinces: "Jawa Tengah" },
  { lat: 0.506566, lng: 101.43779, name: "Pekanbaru", provinces: "Riau" },
  { lat: 2.953963, lng: 98.993453, name: "Pematang Siantar", provinces: "Sumatera Utara" },
  { lat: -0.03109, lng: 109.32199, name: "Pontianak", provinces: "Kalimantan Barat" },
  { lat: -7.772226, lng: 113.166456, name: "Probolinggo", provinces: "Jawa Timur" },
  { lat: -6.592037, lng: 107.271185, name: "Purwakarta", provinces: "Jawa Barat" },
  { lat: -7.4302745, lng: 109.1994041, name: "Purwokerto", provinces: "Jawa Tengah" },
  { lat: -0.48585, lng: 117.1466, name: "Samarinda", provinces: "Kalimantan Timur" },
  { lat: -7.0051, lng: 110.4381, name: "Semarang", provinces: "Jawa Tengah" },
  { lat: -7.4478, lng: 112.7183, name: "Sidoarjo", provinces: "Jawa Timur" },
  { lat: 0.888754, lng: 108.936645, name: "Singkawang", provinces: "Kalimantan Barat" },
  { lat: -7.566667, lng: 110.816667, name: "Solo", provinces: "Jawa Tengah" },
  { lat: -6.936927, lng: 106.88229, name: "Sukabumi", provinces: "Jawa Barat" },
  { lat: -6.8329, lng: 107.9532, name: "Sumedang", provinces: "Jawa Barat" },
  { lat: -7.2575, lng: 112.7521, name: "Surabaya", provinces: "Jawa Timur" },
  { lat: -7.55611, lng: 110.83167, name: "Surakarta", provinces: "Jawa Tengah" },
  { lat: -6.178306, lng: 106.631889, name: "Tangerang", provinces: "Banten" },
  { lat: -6.2889, lng: 106.7181, name: "Tangerang Selatan", provinces: "Banten" },
  { lat: 0.917148, lng: 104.449578, name: "Tanjung Pinang", provinces: "Kepulauan Riau" },
  { lat: -7.359806, lng: 108.162712, name: "Tasikmalaya", provinces: "Jawa Barat" },
  { lat: -7.7956, lng: 110.3695, name: "Yogyakarta", provinces: "DI Yogyakarta" }
];
